// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"896f2292","18":"255c60a4","87":"3c988431","239":"c61b31c7","396":"d04a3c22","455":"ec13b69b","582":"e2621f42","745":"b055f560","913":"b213e4d5","954":"fd39b7df","977":"8257a4e0"}[chunkId] + ".chunk.js";
};